import BooleanCellRenderer from 'ui/AgGridReact/CellRenderers/BooleanCellRenderer';
import AgGrid from 'ui/AgGridReact/AgGridReact';
import AgContainer from 'routes/BudgetModule/components/BudgetProposal/Resource/ExpenseIncome/components/AgContainer';
import { GridOptions, ColDef, ColGroupDef } from 'ag-grid-community';
import React from 'react';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ModuleT, SSO_SUFFIX } from 'business/constants';
import _ from 'lodash';
import { ClientGridT } from './model';
import RouterLinkRenderer from '../CellRenderers/RouterLinkRenderer';
import { ModulesCellRenderer } from '../CellRenderers/ModulesCellRenderer';

const StyAgContainer = styled(AgContainer, { name: 'StyAgContainer' })(() => ({
    marginLeft: '3em',
    height: '80vh !important',
    paddingRight: '5em',
    '.ag-react-container': {
        height: '100%',
    },
}));

type Props = {
    clients: ClientT[];
};

const ClientsGrid = ({ clients }: Props) => {
    const { t } = useTranslation();

    const gridOptions: GridOptions = {
        rowBuffer: 50,
    };

    const columns: (ColDef | ColGroupDef)[] = [
        {
            field: 'name',
            headerName: t('support.grid.name'),
            cellRenderer: 'routerLinkRenderer',
        },
        {
            field: 'modules',
            headerName: t('support.grid.modules'),
            cellRenderer: 'modulesCellRenderer',
            comparator: (valueA: ModuleT[], valueB: ModuleT[]) =>
                _.sortBy(valueA)
                    .join('')
                    .localeCompare(_.sortBy(valueB).join('')),
        },
        {
            field: 'authMethods',
            headerName: t('support.grid.sso'),
            cellRenderer: 'booleanCellRenderer',
            filter: 'agSetColumnFilter',
            valueGetter: ({ data }: { data: ClientGridT }) =>
                data.authMethods.some((item: string) =>
                    item.endsWith(SSO_SUFFIX),
                ),
        },
        {
            field: 'hasUsageHistory',
            headerName: t('support.grid.usageHistory'),
            cellRenderer: 'booleanCellRenderer',
            filter: 'agSetColumnFilter',
        },
    ];

    return (
        <StyAgContainer className="ag-theme-material">
            <AgGrid
                headerHeight={50}
                rowData={clients}
                gridOptions={gridOptions}
                components={{
                    modulesCellRenderer: ModulesCellRenderer,
                    booleanCellRenderer: BooleanCellRenderer,
                    routerLinkRenderer: RouterLinkRenderer,
                }}
                defaultColDef={{
                    columnGroupShow: 'open',
                    menuTabs: [],
                    flex: 2,
                    resizable: false,
                    enableRowGroup: false,
                    sortable: true,
                    suppressNavigable: true,
                }}
                columnDefs={columns}
            />
        </StyAgContainer>
    );
};

export default ClientsGrid;
